import { render, staticRenderFns } from "./NaceCodeSelector.vue?vue&type=template&id=faad659a"
import script from "./NaceCodeSelector.vue?vue&type=script&lang=js"
export * from "./NaceCodeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports